const DISABLED_SP4_SURFACES = Object.freeze({ home: false });

export const normalizeSp4SurfaceRollout = (value) =>
    Object.freeze({
        home:
            value !== null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            value.home === true,
    });

export const readInjectedSp4SurfaceRollout = (
    documentImpl = globalThis.document,
) => {
    const raw = documentImpl
        ?.getElementById('portalNext')
        ?.textContent?.trim();

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const createSp4SurfaceRollout = (readConfig) => {
    let snapshot = DISABLED_SP4_SURFACES;
    let initialized = false;

    return {
        initialize: () => {
            if (!initialized) {
                initialized = true;

                try {
                    snapshot = normalizeSp4SurfaceRollout(readConfig());
                } catch {
                    snapshot = DISABLED_SP4_SURFACES;
                }
            }

            return snapshot;
        },
        isEnabled: (surface) =>
            surface === 'home' && snapshot.home === true,
    };
};

const currentRollout = createSp4SurfaceRollout(
    readInjectedSp4SurfaceRollout,
);

export const initializeSp4SurfaceRollout = () => currentRollout.initialize();
export const isSp4SurfaceEnabled = (surface) =>
    currentRollout.isEnabled(surface);
